// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-411348cb] .el-dialog__body{padding:0;height:600px}", ""]);
// Exports
module.exports = exports;
